/**
 * Online Food Ordering Main Layout
 * Responsive layout with header, navigation, and cart drawer
 */

import { Box } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import CartDrawer from '@/components/cart/CartDrawer';
import MobileCartBar from '@/components/cart/MobileCartBar';
import Footer from './Footer';
import Header from './Header';
import MobileNav from './MobileNav';

export default function MainLayout() {
  const location = useLocation();

  // Don't show mobile cart bar on checkout page
  const hideMobileCartBar = location.pathname === '/checkout';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Header />

      <Box
        component="main"
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          pt: { xs: '56px', sm: '64px' }, // Account for fixed header
          pb: { xs: '56px', sm: 0 }, // Account for mobile nav
        }}
      >
        <Outlet />
      </Box>

      <Footer />
      <CartDrawer />
      {!hideMobileCartBar && <MobileCartBar />}
      <MobileNav />
    </Box>
  );
}
